<script lang="ts">
  import { Button } from "@tastyworks/ui-library"
  import type { ComponentProps } from "svelte"
  import { _ } from "svelte-i18n"
  import InformationalDialog from "./InformationalDialog.svelte"

  type Props = ComponentProps<typeof InformationalDialog>

  let { open, onClose }: Props = $props()
</script>

<InformationalDialog bind:open {onClose}>
  {#snippet titleSnippet()}
    {$_("personalInfo.contactInformation.securityInfo.title")}
  {/snippet}

  {#snippet descriptionSnippet()}
    {$_("personalInfo.contactInformation.securityInfo.description_1")}
    <Button
      variant="link"
      class="h-fit w-fit p-0 font-small-400"
      target="_blank"
      href={$_("personalInfo.contactInformation.securityInfo.href")}
    >
      {$_("personalInfo.contactInformation.securityInfo.linkedText")}
    </Button>
    {$_("personalInfo.contactInformation.securityInfo.description_2")}
  {/snippet}
</InformationalDialog>
